.head {
  margin: 4px 4px 4px;
  font-size: 24px;
  font-weight: 700;
  letter-spacing: -0.01em;
}

/* Период целиком — кнопка: открывает шаг выбора, куда зачислить срок. */
.period {
  position: relative;
  display: flex;
  align-items: center;
  gap: 14px;
  width: 100%;
  padding: 14px var(--pad);
  text-align: left;
  background: var(--surface);
  border: 1px solid var(--card-border);
  border-radius: var(--r-lg);
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
}

.period:active {
  background: var(--surface-sunken);
}

.body {
  flex: 1 1 auto;
  min-width: 0;
}

.name {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 16px;
  font-weight: 600;
}

.monthly {
  display: block;
  margin-top: 2px;
  font-size: 13px;
  color: var(--muted);
}

.right {
  flex: 0 0 auto;
  text-align: right;
}

.price {
  display: block;
  font-size: 16px;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
}

/* Выгода против помесячной оплаты. Зелёный здесь — не статус подписки,
   а «дешевле»: другого смысла у цвета на этом экране нет. */
.save {
  display: inline-block;
  padding: 1px 7px;
  font-size: 12px;
  font-weight: 700;
  color: var(--ok);
  background: var(--ok-wash);
  border-radius: 999px;
}

/* Цена тех же месяцев при помесячной оплате. */
.full {
  display: block;
  margin-top: 2px;
  font-size: 13px;
  color: var(--muted);
  font-variant-numeric: tabular-nums;
}

.best {
  margin-top: 8px;
  border-color: rgb(50 215 75 / 45%);
}

.bestLabel {
  position: absolute;
  top: -9px;
  left: var(--pad);
  padding: 1px 9px;
  font-size: 11px;
  font-weight: 700;
  line-height: 16px;
  color: #06210c;
  background: var(--ok);
  border-radius: 999px;
}

.note {
  margin: 4px 4px 0;
  font-size: 13px;
  color: var(--muted);
}

/* Шторка: выбор, куда зачислить срок */
.caption {
  margin: 0 2px 10px;
  font-size: 13px;
  color: var(--muted);
}

.option {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  padding: 14px var(--pad);
  text-align: left;
  background: var(--surface);
  border: 1px solid var(--card-border);
  border-radius: var(--r-lg);
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
}

.option + .option {
  margin-top: 8px;
}

.selected {
  border-color: var(--ink-soft);
}

.radio {
  display: grid;
  flex: 0 0 auto;
  place-items: center;
  width: 22px;
  height: 22px;
  color: var(--btn-primary-fg);
  border: 2px solid var(--line);
  border-radius: 50%;
}

.selected .radio {
  background: var(--ink);
  border-color: var(--ink);
}

.pay {
  margin-top: 16px;
}

.payNote {
  margin: 8px 2px 0;
  font-size: 12px;
  color: var(--muted);
  text-align: center;
}

.payError {
  color: var(--danger);
}

.methods {
  display: grid;
  /* Столько колонок, сколько способов: карту провайдер может отключить. */
  grid-auto-flow: column;
  grid-auto-columns: minmax(0, 1fr);
  gap: 8px;
}

.method {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  padding: 12px 6px 10px;
  color: var(--ink);
  font: inherit;
  background: none;
  border: 1px solid var(--card-border);
  border-radius: var(--r-md);
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
}

.method:disabled {
  color: var(--muted);
  cursor: default;
  opacity: 0.55;
}

.methodName {
  font-size: 14px;
  font-weight: 600;
}

.methodPrice {
  display: inline-flex;
  align-items: center;
  gap: 2px;
  font-size: 12px;
  color: var(--muted);
  font-variant-numeric: tabular-nums;
}

.method.selected {
  border-color: var(--ink-soft);
  background: var(--accent-wash);
}

.radiogroupEnd {
  margin-bottom: 18px;
}

.waiting {
  margin-top: 4px;
}

.waitingActions {
  display: flex;
  justify-content: center;
  gap: 8px;
  margin-top: 10px;
}
